module.exports = __webpack_public_path__ + "img/iban-number.7afc9435.png";